// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2qN5l","notes":"Notes_notes__33mB8"};